import { useEffect } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import {
  setIsTableLoading,
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setTotalItems,
} from "src/redux/slices/WebcourseSlice";
import { RootState } from "src/redux/store";
import { useDeleteWebcourseMutation, useGetAllWebcourseWithPaginationQuery } from "src/services/WebcourseServices";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import BlogsListing from "./WebCourseListing";

const WebCourseListingWrapper = () => {
  const dispatch = useDispatch();
  const [deleteWebcourse] = useDeleteWebcourseMutation();

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.webcourse);

  const { data, isLoading, isFetching } = useGetAllWebcourseWithPaginationQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["courseName",],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
      dispatch(setIsTableLoading(false));
    } else {
      dispatch(setIsTableLoading(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date Time",
      extraClasses: "w-[120px]",
      renderCell: (row: any) => (
        <div>
          <div className="font-medium text-slate-700">
            {formatedDateTimeIntoIst(row.createdAt, "DD MMM yyyy")}
          </div>
          <div className="text-[13px] font-medium text-slate-400">
            {formatedDateTimeIntoIst(row.createdAt, "hh:mm A")}
          </div>
        </div>
      ),
    },
    {
      field: "courseName",
      headerName: "Blog courseName",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[120x]",
      renderCell: (row: any) => (
        <div className="capitalize"> {row?.courseName} </div>
      ),
    },
    {
      field: "courseName",
      headerName: "Trainer",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[120x]",
      renderCell: (row: any) => (
        <div className="capitalize"> {row?.instructor?.map((trainer: any, index: any) => {
          return (
            <div className="flex flex-col">
              {index + 1}. {trainer?.name}
            </div>
          )
        })} </div>
      ),
    },
    {
      field: "action",
      headerName: "",
      extraClasses: "w-[100px]",
      renderCell: (row: any) => {
        const options = getActionOptions(row?._id);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  const getActionOptions = (row: any) => {
    return [
      // {
      //   label: (
      //     <div className="flex items-center gap-2 text-secondary-main">
      //       <RxPencil1 className="text-lg" /> Edit
      //     </div>
      //   ),
      //   onClick: () => {
      //     navigate(`edit/${row}`);
      //   },
      //   actionName: UserModuleActionTypes.EDIT,
      //   moduleName: UserModuleNameTypes.BLOGS,
      // },
      {
        label: (
          <div className="flex items-center gap-2 font-semibold text-red-600">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Webcourse ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result?.isConfirmed) {
                deleteWebcourse({ id: row }).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.TESTIMONIALS,
      },
    ];
  };

  return (
    <div>
      <BlogsListing
        rows={items}
        columns={columns}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
    </div>
  );
};

export default WebCourseListingWrapper;
